import React from 'react';
import { signOut } from 'firebase/auth';
import { auth } from '../data/firebase';

interface LogoutButtonProps {
  className?: string;
}

const LogoutButton: React.FC<LogoutButtonProps> = ({ className }) => {
  const handleLogout = async () => {
    try {
      await signOut(auth);
      console.log('User logged out successfully');
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  return (
    <div className={`LogoutButton ${className || ''}`}>
      <button onClick={handleLogout}>Logout</button>
    </div>
  );
};

export default LogoutButton;
